import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IGetCatchUpCarouselUseCase } from '../../core/usecases/cmsCarousel/GetCatchUpCarouselUseCase';
import { IGetCatchUpListParams, IGetCatchUpListResponse } from '../../entity/interface/iCmsCarousel';

export interface ICmsCarouselService {
    getCatchUpCarousel(
        dataSource: string,
        apiKey: string,
        param?: IGetCatchUpListParams,
        isMixedCatchup?: boolean
    ): Promise<IGetCatchUpListResponse['data']>;
}

export class CmsCarouselService implements ICmsCarouselService {
    // Lazy getter for dependency to avoid circular dependencies
    private get getCatchUpCarouselUseCase(): IGetCatchUpCarouselUseCase {
        return container.resolve<IGetCatchUpCarouselUseCase>(DI.USECASES.IGetCatchUpCarouselUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getCatchUpCarousel(
        dataSource: string,
        apiKey: string,
        params?: IGetCatchUpListParams,
        isMixedCatchup?: boolean
    ): Promise<IGetCatchUpListResponse['data']> {
        const response = await this.getCatchUpCarouselUseCase.execute(dataSource, apiKey, params, isMixedCatchup);
        return response;
    }
}
